import { useStoreModalTransactionHistory } from '~/stores/strapi/modals/transactionHistory';
import { ESsPlayerPaymentStatus } from '~/types/softswiss/ssPlayerPayments';
import type { ISsPlayerPayments } from '~/types/softswiss/ssPlayerPayments';

export const getCashOutStatus = (cashoutData: ISsPlayerPayments) => {
  const { finished_at, success } = cashoutData;

  const checksResults: Record<ESsPlayerPaymentStatus, boolean> = {
    [ESsPlayerPaymentStatus.IN_PROGRESS]: !finished_at, // not finished
    [ESsPlayerPaymentStatus.SUCCESS]: !!success && !!finished_at, // success = true, and finished
    [ESsPlayerPaymentStatus.REJECTED]: !success && !!finished_at, // success = false, and finished
  };

  const possibleStatus = Object.entries(checksResults).find(([_, checkRes]) => checkRes);

  // case something is wrong
  if (!possibleStatus || !possibleStatus?.length) {
    return ESsPlayerPaymentStatus.IN_PROGRESS;
  }

  return possibleStatus[0] as ESsPlayerPaymentStatus;
};

export const getStatusTitle = (status: ESsPlayerPaymentStatus) => {
  const transactionHistoryModal = useStoreModalTransactionHistory();
  let statusTitle = '';

  switch (status) {
    case ESsPlayerPaymentStatus.REJECTED:
      statusTitle = transactionHistoryModal.statusDiscardeTitle;
      break;
    case ESsPlayerPaymentStatus.IN_PROGRESS:
      statusTitle = transactionHistoryModal.statusPendingTitle;
      break;
    default:
      statusTitle = transactionHistoryModal.statusAcceptedTitle;
  }

  return statusTitle;
};
